import { Box, Button, Container, Flex, Heading, Text, TextField } from "@radix-ui/themes"
import React, { useEffect, useState } from "react"
import PasswordInput from "../../components/controls/inputs/PasswordInput"
import { AccessibilityIcon, EnterIcon, PersonIcon } from "@radix-ui/react-icons"
import PhoneInput from "../../components/controls/inputs/PhoneInput"
import useLogin from '../../core/services/hooks/useLogin'
import useRegistration from '../../core/services/hooks/useRegistration'
import { Link, useNavigate } from "react-router"
import { ROUTES } from "../../routes/constants"
import { toast, ToastContainer } from "react-toastify"
export default function Login() {
    const [status, setStatus] = useState<'auth' | 'registration'>('auth')
    const [login, setLogin] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [phoneNumber, setPhoneNumber] = useState<string>('')
    const {login: auth, isLoading, error, errors} = useLogin({login, password})
    const {registration, isLoading: isLoadingRegistration, error: errorRegistration, errors: errorsRegistration} = useRegistration({login, password, email, phone_number: phoneNumber})
    const navigation = useNavigate()
    const authorization = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault()
        if(status === 'auth') {
           await auth()
        }
        else {
            await registration()
        }
    }


    useEffect(() => {
        if(error) toast.error(error)
    }, [error])

    useEffect(() => {
        if(errorRegistration) toast.error(errorRegistration)
    }, [errorRegistration])

    return (
        <Flex align={'center'} justify={'center'} className="pt-20">
            <ToastContainer />
            <Flex justify={'center'} direction={'column'} gap={'3'} className="p-5 shadow-xl border-2">
                <Flex gap={'3'} align={'center'} justify={'center'}> 
               <Button 
               disabled={status === 'auth'} 
               onClick={() => setStatus('auth')}
               >
                <EnterIcon />
                Авторизация
               </Button>
               <Button 
               disabled={status === 'registration'} 
               onClick={() => setStatus('registration')}
               >
                <PersonIcon />
                Регистрация
               </Button>
               </Flex>
               <Box as="div"> 
               <Heading mb="2" size="4">
                {status === 'auth' ? "Авторизация" : "Регистрация"}
                </Heading>
                </Box>
                <Flex gap={'3'} direction={'column'}>
                    <Text>{status === 'auth' ? "Емейл*" : "Логин*"}</Text>
                    <TextField.Root value={login} onChange={e => setLogin(e.target.value)} placeholder={status === 'auth' ? "Емейл" : "Логин"}>
                        <TextField.Slot>

                        </TextField.Slot>
                    </TextField.Root>
                    {errorsRegistration.login && <Text color="red">{errorsRegistration.login.msg}</Text>}
                    <Text>Пароль*</Text>
                    <PasswordInput value={password} onChange={e => setPassword(e.target.value)} placeholder="Пароль" />
                    {
                        status === 'registration' ?
                        <> 
                    {errorsRegistration.password && <Text color="red">{errorsRegistration.password.msg}</Text>}
                    <Text>Емейл*</Text>
                    <TextField.Root value={email} onChange={e => setEmail(e.target.value)} placeholder="Емейл">
                        <TextField.Slot>

                        </TextField.Slot>
                    </TextField.Root>
                    {errorsRegistration.email && <Text color="red">{errorsRegistration.email.msg}</Text>}
                    <Text>Номер телефона*</Text>
                  
                    <PhoneInput value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder="+7 (666) 666-66-66" />
                    {errorsRegistration.phone_number && <Text color="red">{errorsRegistration.phone_number.msg}</Text>}
                    </>
                    
                    : ''
}
                </Flex>
                <Button onClick={async (e) => await authorization(e)} loading={isLoading || isLoadingRegistration || false}> 
                    {
                    status === 'auth' ?
                    <> 
                    <EnterIcon />
                    Авторизация
                    </>
                    :
                    <> 
                    <PersonIcon />
                   Регистрация
                    </>
}                    
                </Button>
                <Link to={ROUTES.RESET_PASSWORD_ROUTE}> 
                <Button variant='ghost'>
                    <AccessibilityIcon />
                    Забыли пароль?
                </Button>
                </Link>
            </Flex>
        </Flex>
    )
}